import React from 'react';
import './ContactUs.css';

function ContactUs() {
  return (
    <div className="container">
      <h1>Contact Us</h1>

      <fieldset>
        <legend>Email</legend>
        <p>support@spectsgenie.com</p>
      </fieldset>

      <fieldset>
        <legend>Phone</legend>
        <p>+91 8904816421</p>
      </fieldset>

      <fieldset>
        <legend>Address</legend>
        <p>Shop no. 2,3,4, Ground Floor, No. 84, 1st cross, Dasarahalli Main Rd, Bhuvaneswari Nagar, Bengaluru, Karnataka 560024</p>
      </fieldset>
    </div>
  );
}

export default ContactUs;
